import { useEffect } from "react";
import type { ReactNode } from "react";
import { cssVariables, tokens, validatorCssVariables } from "./tokens";

/**
 * Fija data-type="mercedes" en <html> (admin.jsx:3791) y publica los tokens
 * como variables CSS en :root. Un único tema: el portal no tiene modo oscuro
 * alterno (SPEC-201 §7, fuera de alcance) ni selector de tema.
 *
 * `--danger`/`--danger-dim`/`--danger-line` en `:root` son el hex del
 * portal; el validador tiene el suyo propio (DESIGN-TOKENS.md §3-4, PLAN-004
 * §4.5, no intercambiables) y lo recibe acotado a `.sc-shell` — su
 * contenedor raíz (`validator/access/AccessLayout.tsx`) — sin tocar el token
 * global ni ningún archivo de `validator/**`.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.documentElement.setAttribute("data-type", "mercedes");
    document.documentElement.style.background = tokens.pageBackground;
  }, []);

  return (
    <>
      <style>{`
        :root { ${cssVariables} }
        .sc-shell { ${validatorCssVariables} }
      `}</style>
      {children}
    </>
  );
}
